<div class="main-container">
    <router-outlet />
</div>
